import React from 'react';
const variants = {
  primary: 'btn-primary',
  secondary: 'btn-secondary',
  ghost: 'btn-ghost',
  danger: 'btn-danger',
};
const Button = ({ variant='primary', className='', as='button', children, ...rest }) => {
  const Tag = as;
  return <Tag className={`${variants[variant] || variants.primary} ${className}`} {...rest}>{children}</Tag>;
};
export default Button;
